import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Icon from '../AppIcon';

const NavigationBar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const navigationItems = [
    {
      label: 'Dashboard',
      path: '/agent-dashboard',
      icon: 'LayoutDashboard',
      tooltip: 'Agent workspace and call controls'
    },
    {
      label: 'Contacts',
      path: '/contact-directory',
      icon: 'Users',
      tooltip: 'Customer directory and contact management'
    },
    {
      label: 'History',
      path: '/call-history',
      icon: 'Clock',
      tooltip: 'Call records and performance review'
    },
    {
      label: 'Monitor',
      path: '/supervisor-monitor',
      icon: 'Monitor',
      tooltip: 'Real-time agent oversight and monitoring'
    },
    {
      label: 'Analytics',
      path: '/call-analytics',
      icon: 'BarChart3',
      tooltip: 'Performance analytics and reporting'
    }
  ];

  const secondaryItems = [
    {
      label: 'Settings',
      path: '/system-settings',
      icon: 'Settings',
      tooltip: 'System configuration and user management'
    }
  ];

  const handleNavigation = (path) => {
    navigate(path);
    setIsMobileMenuOpen(false);
  };

  const isActivePath = (path) => {
    return location?.pathname === path;
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 768) {
        setIsMobileMenuOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <nav className="fixed top-0 left-0 right-0 z-1000 bg-white border-b border-slate-200 shadow-subtle">
      <div className="max-w-full px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <div className="flex items-center">
            <div className="flex-shrink-0 flex items-center">
              <div className="flex items-center space-x-2">
                <div className="w-8 h-8 bg-primary rounded-lg flex items-center justify-center">
                  <Icon name="Phone" size={20} color="white" />
                </div>
                <span className="text-xl font-semibold text-slate-900">CallCenter Pro</span>
              </div>
            </div>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:block">
            <div className="ml-10 flex items-baseline space-x-1">
              {navigationItems?.map((item) => (
                <button
                  key={item?.path}
                  onClick={() => handleNavigation(item?.path)}
                  className={`nav-item micro-hover micro-click focus-ring ${
                    isActivePath(item?.path) ? 'active' : ''
                  }`}
                  title={item?.tooltip}
                >
                  <Icon name={item?.icon} size={18} className="mr-2" />
                  {item?.label}
                </button>
              ))}
              
              {/* More Menu */}
              <div className="relative ml-3">
                <div className="flex items-center space-x-1">
                  {secondaryItems?.map((item) => (
                    <button
                      key={item?.path}
                      onClick={() => handleNavigation(item?.path)}
                      className={`nav-item micro-hover micro-click focus-ring ${
                        isActivePath(item?.path) ? 'active' : ''
                      }`}
                      title={item?.tooltip}
                    >
                      <Icon name={item?.icon} size={18} className="mr-2" />
                      {item?.label}
                    </button>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="inline-flex items-center justify-center p-2 rounded-md text-slate-600 hover:text-slate-900 hover:bg-slate-50 focus-ring micro-hover"
              aria-expanded="false"
            >
              <span className="sr-only">Open main menu</span>
              <Icon name={isMobileMenuOpen ? "X" : "Menu"} size={24} />
            </button>
          </div>
        </div>
      </div>
      {/* Mobile Navigation Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden fade-in">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-white border-t border-slate-200">
            {navigationItems?.map((item) => (
              <button
                key={item?.path}
                onClick={() => handleNavigation(item?.path)}
                className={`w-full text-left nav-item micro-hover micro-click focus-ring ${
                  isActivePath(item?.path) ? 'active' : ''
                }`}
              >
                <Icon name={item?.icon} size={18} className="mr-3" />
                {item?.label}
              </button>
            ))}
            
            <div className="border-t border-slate-200 pt-2 mt-2">
              {secondaryItems?.map((item) => (
                <button
                  key={item?.path}
                  onClick={() => handleNavigation(item?.path)}
                  className={`w-full text-left nav-item micro-hover micro-click focus-ring ${
                    isActivePath(item?.path) ? 'active' : ''
                  }`}
                >
                  <Icon name={item?.icon} size={18} className="mr-3" />
                  {item?.label}
                </button>
              ))}
            </div>
          </div>
        </div>
      )}
    </nav>
  );
};

export default NavigationBar;